export default __webpack_public_path__ + "static/media/icon-arrow-back.67b16ac3.svg";